import { render, staticRenderFns } from "./CharactersMulticlassImprovements.vue?vue&type=template&id=495e1057&lang=pug&"
import script from "./CharactersMulticlassImprovements.vue?vue&type=script&lang=ts&"
export * from "./CharactersMulticlassImprovements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports